import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import { champName, champPath } from "../misc/Static";
import styles from "./Skill.module.css";
import Tippy from "@tippyjs/react";

const Skill = ({ cid, id, type }) => {
  const tips = useContext(TipContext);
  const tip =
    tips.skill[cid] && tips.skill[cid][id.toUpperCase()]
      ? tips.skill[cid][id.toUpperCase()]
      : "Loading...";
  return (
    <>
      <Tippy
        content={
          <div
            className={
              tips.skill[cid] && tips.skill[cid][id.toUpperCase()]
                ? ""
                : styles.loading
            }
            dangerouslySetInnerHTML={{ __html: tip }}
          />
        }
        onShow={() => {
          if (!tips.skill[cid]) tips.setShowSkill(cid);
        }}
        maxWidth={480}
      >
        <div>
          <img
            src={`https://cdn5.xdx.gg/skill24/${champPath(cid)}_${id}.webp`}
            srcSet={`https://cdn5.xdx.gg/skill24/${champPath(
              cid
            )}_${id}.webp 24w,
            https://cdn5.xdx.gg/skill48/${champPath(cid)}_${id}.webp 48w,
            https://cdn5.xdx.gg/skill72/${champPath(cid)}_${id}.webp 78w`}
            alt={champName(cid) + " " + id.toUpperCase()}
            height="24"
            width="24"
          />
          <div className={styles[type + "_key"]}>{id.toUpperCase()}</div>
        </div>
      </Tippy>
    </>
  );
};

export default Skill;
